import moment from 'moment';

function toLocalDateTimeFilter() {
    return (value: string): string => moment(value).format('lll');
}

export default {
    name: 'toLocalDateTime',
    definition: toLocalDateTimeFilter
};
